









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IInputMethodBehavior, InputMethodKinds } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class InputMethodBehaviorEditor extends Mixins(ModelEditableMixin) {

  @Prop()
  inputMethodOptions: StandardOption<InputMethodKinds>[];

  writePropertyWhenValid: (writer: (source: IInputMethodBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IInputMethodBehavior) => T, defaultValue: T) => T;

  get kind(): InputMethodKinds {
    return this.readPropertyOrDefault(s => s.kind, InputMethodKinds.None);
  }

  set kind(value: InputMethodKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }
}
